<template>
  <a-modal
    title="Upload file"
    :visible="visible"
    @cancel="closeFn()"
    :getContainer="() => document.getElementById('app')"
    width="900px"
    :destroyOnClose="true"
  >
    <template slot="footer">
      <div>
        <span>
          <a-button @click="editTagsBatch" v-if="isBatch">Batch add labels</a-button>
          <a-button @click="editNameBatch" v-if="isBatch">Batch modify name</a-button>
          <a-button
            @click="closeFn()"
            >Close</a-button
          >
        </span>
      </div>
    </template>
    <Upload
      :customerCategoryId="customerCategoryId"
      :url="url"
      ref="upload"
      @closeBack="closeFn()"
      @isBatchBack="
        value => {
          isBatch = value
        }
      "
    />
    <a-modal
      title="Add label"
      :visible="tagsEdit"
      @cancel="tagsEdit = false"
      :getContainer="() => document.getElementById('app')"
      width="840px"
      @ok="okTagsEdit"
      :destroyOnClose="true"
    >
      <EditTagsBatch ref="editTagsBatch" />
    </a-modal>
    <a-modal
      title="Modify name"
      :visible="visibleEdit"
      @cancel="visibleEdit = false"
      :getContainer="() => document.getElementById('app')"
      width="840px"
      @ok="okEdit"
      :destroyOnClose="true"
    >
      <EditTextBatch ref="editTextBatch" />
    </a-modal>
  </a-modal>
</template>

<script>
import EditTextBatch from './components/editTextBatch.vue'
import EditTagsBatch from './components/editTagsBatch.vue'
import Upload from './components/upload.vue'
import { editGruopNames, editGruopTags } from '@/api/myGallery'
import { languageKey } from '@/utils/const'

export default {
  data() {
    return {
      visible: false,
      visibleEdit: false,
      tagsEdit: false,
      isBatch: false,
      languageKey: languageKey
    }
  },
  props: ['url', 'customerCategoryId', 'delUrl'],
  methods: {
    closeFn() {
      this.visible = false
      this.isBatch = false
      this.$emit('getUploaderList')
    },
    editTagsBatch() {
      this.tagsEdit = true
      this.$nextTick(() => {
        const { editTagsBatch } = this.$refs
        const { upload } = this.$refs
        editTagsBatch.fileList = JSON.parse(JSON.stringify(upload.uploadList))
      })
    },
    editNameBatch() {
      this.visibleEdit = true
      this.$nextTick(() => {
        const { editTextBatch } = this.$refs
        const { upload } = this.$refs
        editTextBatch.language = 1
        editTextBatch.fileList = JSON.parse(JSON.stringify(upload.uploadList))
      })
    },
    okEdit() {
      const { editTextBatch } = this.$refs
      const { form, editType, fileList, batchName, sameName } = editTextBatch
      form.validateFields((err, values) => {
        if (!err) {
          let data = {}
          data.ids = fileList.map(item => item.id).join(',')
          // data.language = language
          if (editType === 1) {
            // data.name = Object.values(values)
            this.languageKey.forEach((it, i) => {
              data[it] = fileList.map(item => {
                return item.material_name_alias[i]
              })
            })
          } else if (editType === 2) {
            // const names = values.nameGroup.split(/\n/)
            // data.name = names
            for (const it in batchName) {
              if (batchName[it]) {
                data[it] = batchName[it].split('\n')
              }
            }
          } else {
            // data.name = values.nameSame
            data.is_all = 1
            data = { ...data, ...sameName }
          }
          editGruopNames(data).then(res => {
            const {
              upload: { uploadList }
            } = this.$refs
            const { data } = res
            if (editType === 1) {
              uploadList.map((item, index) => {
                item.name = data[index].material_name_alias[1]
                item.brands = data[index].brand_infringement_words
                item.risks = data[index].risk_words
                item.material_name_alias = data[index].material_name_alias
              })
            } else if (editType === 2) {
              uploadList.map((item, index) => {
                if (data[index]) {
                  item.name = data[index].material_name_alias[1]
                  item.brands = data[index].brand_infringement_words
                  item.risks = data[index].risk_words
                  item.material_name_alias = data[index].material_name_alias
                }
              })
            } else {
              uploadList.map((item, index) => {
                if (data[index]) {
                  item.name = data[index].material_name_alias[1] || ''
                  item.brands = data[index].brand_infringement_words
                  item.risks = data[index].risk_words
                  item.material_name_alias = data[index].material_name_alias
                }
                // this.languageKey.forEach((it, i) => {
                //   if (sameName[it]) {
                //     item.material_name_alias[i] = sameName[it]
                //   }
                // })
              })
            }
            this.visibleEdit = false
          })
        }
      })
    },
    okTagsEdit() {
      const { editTagsBatch } = this.$refs
      const { form, editType, fileList, tagsList } = editTagsBatch
      form.validateFields((err, values) => {
        if (!err) {
          const data = {
            save_type: 0
          }
          data.ids = fileList.map(item => item.id).join(',')
          if (editType === 1) {
            data.tags = fileList.map(item => item.tags.join(','))
          } else if (editType === 2) {
            data.tags = [tagsList.join(',')]
          }
          editGruopTags(data).then(res => {
            const {
              upload: { uploadList }
            } = this.$refs
            const { data } = res
            console.log('uploadList===', uploadList)
            if (editType === 1) {
              uploadList.map((item, index) => {
                item.tags = fileList[index].tags
                item.brands = data[item.id].brand_infringement_words
                item.risks = data[item.id].risk_words
              })
            } else if (editType === 2) {
              uploadList.map((item, index) => {
                item.tags = tagsList
                item.brands = data[item.id].brand_infringement_words
                item.risks = data[item.id].risk_words
              })
            }
            this.tagsEdit = false
          })
        }
      })
    }
  },
  components: {
    Upload,
    EditTextBatch,
    EditTagsBatch
  },

  mounted() {}
}
</script>

<style></style>
